import store from "@store";

import {Model} from "@vuex-orm/core";
import ArticlesHasAccessorygroup from "@models/helpers/ArticlesHasAccessorygroup";
import ArticleHasFeature from "@models/helpers/ArticleHasFeature";
import DevicepackagesHasArticle from "@models/helpers/DevicepackagesHasArticle";
import ArticleHasChild from "@models/helpers/ArticleHasChild";
import ChildArticle from "@models/helpers/Article";
import Articledetail from "@models/helpers/Articledetail";
import File from "@models/helpers/File";
import Countryprice from "@models/helpers/Countryprice";
import Rule from "@models/helpers/Rule";
import Documentfile from "@models/helpers/Documentfile";

export default class Article extends Model {
  static entity = "articles";

  static fields() {
    return {
      id: this.attr(null),
      art_no: this.attr(null),
      available: this.attr(null),
      connection: this.attr(null),
      enthalpie: this.attr(null),
      name: this.attr(null),
      passivhouse: this.attr(null),
      wg: this.attr(null),

      accessorygroup: this.hasOne(ArticlesHasAccessorygroup, "articles_id"),
      features: this.hasMany(ArticleHasFeature, "articles_id"),
      devicepackages: this.hasMany(DevicepackagesHasArticle, "articles_id"),
      childs: this.hasMany(ArticleHasChild, "articles_id"),
      parent: this.hasOne(ArticleHasChild, "child_id"),

      details: this.hasOne(Articledetail, "articles_id"),
      files: this.hasMany(File, "articles_id"),
      price: this.hasOne(Countryprice, "articles_id"),
      rules: this.hasMany(Rule, "article_id"),
      documentfile: this.hasMany(Documentfile, "article_id"),

      quantity: this.number(0),
    };
  }

  getSortIndex() {
    const accessorygroup = ArticlesHasAccessorygroup.query().where("articles_id", this.id).first();
    if (!accessorygroup) return null;
    return accessorygroup.sort_index;
  }

  getFeatureValueById(id) {
    var feature = this.features.find((feature) => feature.feature_id == id);
    if (feature) return feature.value;
    else return null;
  }

  checkFeatureValue(featureId, value) {
    if (this.features.some((feature) => feature.feature_id == featureId && feature.value == value)) return true;
    else return false;
  }

  getInstallationPosition() {
    var feature = this.features.find((feature) => feature.feature_id == 39);
    if (feature) return feature.value;
    else return null;
  }

  getMinDeviceAirvolume() {
    var feature = this.features.find((feature) => feature.feature_id == 26);
    if (feature) return feature.value;
    else return null;
  }

  getMaxDeviceAirvolume(ewt = null) {
    var featureId = 27;
    if (ewt == 1) featureId = 36;
    if (ewt == 2) featureId = 37;
    var feature = this.features.find((feature) => feature.feature_id == featureId);
    if (feature) return feature.value;
    else return null;
  }

  setChilds(unitId) {
    var childs = [];
    this.childs.forEach((child) => {
      var childArticle = ChildArticle.query().where("id", child.child_id).with(["childs", "accessorygroup"]).first();
      if (!childArticle) return;
      if (childArticle.childs && childArticle.childs.length > 0) childArticle.setChilds(unitId);
      childs.push({
        units_id: unitId,
        articles_id: childArticle.id,
        quantity: child.quantity_default,
        accessorygroups_id: childArticle.accessorygroup.accessorygroups_id
      });
    });
  }

  getDocument(type) {
    const document = Documentfile.query().where("article_id", this.id).where("type_id", type).first();
    if (!document) return "";
    if (type == 1) return store.state.localization.articleImageUrl + document.file_name;
    if (type == 2) return store.state.localization.articleDatasheetUrl + document.file_name;
    return document.file_name;
  }

  getProductPage() {
    // localization.selectUrl + / + article.art_no
    return store.state.localization.selectUrl + "/de/get/product?ref_no=" + this.art_no;
  }

  getDetail(type) {
    const detail = Articledetail.query().where("articles_id", this.id).first();
    if (!detail || !detail[type]) return "";
    return detail[type];
  }

  getPrice() {
    const price = Countryprice.query().where("article_id", this.id).first();
    if (!price || !price.unit_price) return "-";
    return price.unit_price;
  }

  getTotalPrice() {
    const price = Countryprice.query().where("article_id", this.id).first();
    if (!price || !price.unit_price) return "-";
    return parseInt(price.unit_price * this.quantity);
  }

  getAccessorygroupId(ids = null) {
    const articlesHasAccessorygroup = ArticlesHasAccessorygroup.query().where("articles_id", this.id).get();
    if (articlesHasAccessorygroup.length <= 0) return null;
    if (articlesHasAccessorygroup.length == 1 || ids == null || ids.length <= 0) return articlesHasAccessorygroup[0].accessorygroups_id;

    let id = null;
    articlesHasAccessorygroup.some((articleHasAccessorygroup) => {
      if (ids.includes(articleHasAccessorygroup.accessorygroups_id)) {
        id = articleHasAccessorygroup.accessorygroups_id;
        return true;
      }
    });
    if (id == null) return articlesHasAccessorygroup[0].accessorygroups_id;
    return id;
  }
}
